import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const defaultNS = "common";
export const SUPPORTED_LANGUAGES = ["en", "da", "sv", "no"] as const;

// Import translation files directly
import enCommon from "../../public/locales/en/common.json";
import daCommon from "../../public/locales/da/common.json";
import svCommon from "../../public/locales/sv/common.json";
import noCommon from "../../public/locales/no/common.json";

const resources = {
  en: {
    common: enCommon,
  },
  da: {
    common: daCommon,
  },
  sv: {
    common: svCommon,
  },
  no: {
    common: noCommon,
  },
};

// LanguageDetector removed: it ran at module init and set a different language
// on server ("en") vs client (detected from ?lang=), causing React hydration
// mismatches and DOMException crashes on translation-heavy pages.
// Language is now set explicitly by I18nProvider via a lang prop from the server.
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  supportedLngs: ["en", "da", "sv", "no"],
  load: "languageOnly",
  nonExplicitSupportedLngs: true,
  lowerCaseLng: true,
  defaultNS,
  ns: [defaultNS],
  resources,
  interpolation: {
    escapeValue: false,
  },
  saveMissing: false,
  returnEmptyString: false,
  returnNull: false,
});

export default i18n;
